export const textWithLink = (
  text: string,
  replaceWith: string = `<a target="_blank" href="$&">$&</a>`,
) => {
  return {
    __html: text && text.replace(/(\w+):\/\/([\w.]+\/?)\S*/, replaceWith),
  }
}
